
export default {
    selectedOrganization: state => state.selectedOrganization,
    organizationPaymentStatus: state => state.selectedOrganizationPaymentSetup,
    selectedOrganizationId: state => state.selectedOrganizationId,
    selectedOrganizationBillingEmail: state => state.selectedOrganizationBillingEmail,
    selectedOrganizationActiveModels: state => state.selectedOrganizationActiveModels,
    isComplianceVisible: state => state.isComplianceVisible,
};
